"use client";

import { parseAsString, useQueryState } from "nuqs";


export function useCompanyDetailModal() {
  const [companyId, setCompanyId] = useQueryState(
    "companyId",
    parseAsString.withOptions({ history: "push" }),
  );

  return {
    companyId,
    isOpen: Boolean(companyId),
    openCompanyDetail: (id: string) => {
      if (id) setCompanyId(id);
    },
    closeCompanyDetail: () => {
      setCompanyId(null);
    },
  };
}
